module.exports = __webpack_public_path__ + "img/dsci0134.079f46da.jpg";